/* Combined family picker (cubes-style groups) — shared functions.
   Extracted from product-form-component-product-group.liquid 2026-08-25:
   the drawer injects the picker via x-html, which never executes inline
   <script> blocks, so pills threw "gpMemberFilter is not defined" in the
   quick-buy drawer. Loaded sitewide from theme.liquid (defer).

   Roots: on a PDP the picker lives in a .shopify-section; in the
   quick-buy drawer it lives in the modal's [data-might-be-empty] host,
   which is created fresh on every open (so filter state and observers
   never leak between products). In-drawer member swaps morph the drawer
   content in place via the same selectGroupProduct anchor as the PDP. */

(function () {
  function gpRoot(el) {
    return el.closest('.shopify-section') || el.closest('[data-might-be-empty]');
  }

  window.gpMemberFilter = function (btn, handle, url, optionCount, currentHandle) {
    var root = gpRoot(btn) || document;
    var chips = root.querySelectorAll('[data-gp-member]');
    // rev 2026-08-25 (Hagan): a pill for ANOTHER family member always
    // NAVIGATES to that member's page (first variant selected, pill
    // carried via gp_pill) — the old in-place foreign filter left the
    // title/price/ATC pointing at the previous selection ("loads but
    // doesn't select anything"). Same pattern as the book tabs.
    if (handle !== 'all' && handle !== currentHandle) {
      if (optionCount > 1) {
        url += (url.indexOf('?') === -1 ? '?' : '&') + 'gp_pill=' + encodeURIComponent(handle);
      }
      // no-reload swap when available. The swap REPLACES the whole
      // section node, so the intended filter is parked on window (which
      // survives — no reload) and a global observer applies it to the
      // NEW section once it lands. The tapped member's pill stays active
      // on landing — including single-variant members like Daniel Tiger.
      if (!window.gpSwapWithFilter(root, url, handle)) window.location = url;
      return;
    }
    if (!chips.length) {
      if (!window.gpSwapWithFilter(root, url, 'all')) window.location = url;
      return;
    }
    // Selecting a variant makes the theme re-render the picker, wiping
    // inline chip styles + pill states. The chosen filter lives on the
    // ROOT (survives re-renders) and gpApplyFilter re-paints from it; a
    // MutationObserver re-applies after any re-render.
    root.setAttribute('data-gp-filter', handle);
    window.gpApplyFilter(root);
    window.gpWatchFilter(root);
  };

  window.gpSwapWithFilter = function (root, url, filterHandle) {
    var a = root.querySelector && root.querySelector('[data-gp-swap]');
    if (!a) return false;
    if (root.matches && root.matches('.shopify-section')) {
      // PDP: the swap REPLACES the section node — park the filter on
      // window and let the global observer apply it to the new section
      window.__gpPendingFilter = filterHandle;
      window.__gpSwapFromRoot = root;
      window.gpArmSwapWatch();
    } else {
      // drawer (rev 2026-08-25): selectGroupProduct morphs the drawer
      // CONTENT but the [data-might-be-empty] host survives — the
      // filter lives on it and the childList watcher re-applies once
      // the new member's markup lands
      root.setAttribute('data-gp-filter', filterHandle);
      window.gpApplyFilter(root);
      window.gpWatchFilter(root);
    }
    a.setAttribute('href', url);
    a.click();
    return true;
  };

  window.gpChipSwap = function (el) {
    var root = gpRoot(el);
    if (!root) return false; // unknown context: let the link navigate
    var filter = root.getAttribute('data-gp-filter');
    return window.gpSwapWithFilter(root, el.getAttribute('href'), filter && filter.indexOf('bkt-') === 0 ? filter : 'all');
  };

  window.gpArmSwapWatch = function () {
    if (window.__gpSwapWatch) return;
    window.__gpSwapWatch = new MutationObserver(function () {
      if (!window.__gpPendingFilter) return;
      var pill = document.querySelector('[data-gp-pillfilter]');
      if (!pill) return;
      var root = pill.closest('.shopify-section');
      // still the pre-swap section? wait for the new one
      if (!root || root === window.__gpSwapFromRoot) return;
      var pending = window.__gpPendingFilter;
      window.__gpPendingFilter = null;
      setTimeout(function () {
        root.setAttribute('data-gp-filter', pending);
        window.gpApplyFilter(root);
        window.gpWatchFilter(root);
      }, 50);
    });
    window.__gpSwapWatch.observe(document.body, { childList: true, subtree: true });
  };

  window.gpApplyFilter = function (root) {
    var handle = root.getAttribute('data-gp-filter');
    if (!handle) return;
    root.querySelectorAll('[data-gp-pillfilter]').forEach(function (b) {
      if (b.getAttribute('data-gp-pillfilter') === handle) { b.setAttribute('aria-current', 'true'); } else { b.removeAttribute('aria-current'); }
    });
    // bucket filters (bkt-*, catalog Batch B pill rule): painting is done
    // by Liquid-emitted attribute-selector CSS keyed on [data-gp-filter] —
    // clear inline styles so the CSS can take over (a bucket handle never
    // equals a member handle, so the per-member match below would hide all)
    if (handle.indexOf('bkt-') === 0) {
      root.querySelectorAll('[data-gp-member]').forEach(function (el) {
        el.style.display = '';
      });
      return;
    }
    root.querySelectorAll('[data-gp-member]').forEach(function (el) {
      el.style.display = handle === 'all' || el.getAttribute('data-gp-member') === handle ? '' : 'none';
    });
  };

  window.gpWatchFilter = function (root) {
    if (root.__gpFilterWatch) return;
    var t = null;
    root.__gpFilterWatch = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { window.gpApplyFilter(root); }, 60);
    });
    // childList only: our own style/aria writes don't re-trigger it
    root.__gpFilterWatch.observe(root, { childList: true, subtree: true });
  };

  // 2026-10-19: a family chip tapped BEFORE its picker island hydrates is a
  // plain link, so the browser navigated and pushed a history entry per
  // Pal - Back then stepped through every Pal instead of returning to the
  // collection. Hydrated taps already swap with replaceState; make the
  // pre-hydration tap match by replacing the entry too. PDP only: in the
  // quick-buy drawer a replace would drop the collection page from history.
  // 2026-10-19 (Hagan): a chip tapped while a brand pill is active keeps
  // that pill - the swap re-renders the picker with "All" active, so the
  // filter is parked for the new section (or carried as gp_pill when the
  // tap navigates). Only visible chips are tappable, so the tapped member
  // is always inside the active brand.
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('[data-gp-member] a[href], a[data-gp-member][href]');
    if (!a || a.target === '_blank') return;
    var root = gpRoot(a);
    var filter = root && root.getAttribute('data-gp-filter');
    var keep = filter && filter.indexOf('bkt-') === 0 ? filter : null;
    if (!a.closest('.shopify-section')) return; // drawer: the host keeps its filter
    var island = a.closest('data-island');
    if (!island || island.hasAttribute('ready')) {
      // hydrated: Alpine swaps in place. The swap now waits for the new
      // photos (utils.js GLO-MOD), so ring the tapped swatch right away -
      // the tap registers instantly while the old page stays painted.
      var row = a.closest('[data-gp-member]') && a.closest('[data-gp-member]').parentElement;
      if (row) {
        row.querySelectorAll('[data-gp-member] a.is-selected').forEach(function (x) { x.classList.remove('is-selected'); });
        a.classList.add('is-selected');
      }
      if (keep) {
        window.__gpPendingFilter = keep;
        window.__gpSwapFromRoot = root;
        window.gpArmSwapWatch();
      }
      return;
    }
    e.preventDefault();
    var url = a.href;
    if (keep) url += (url.indexOf('?') === -1 ? '?' : '&') + 'gp_pill=' + encodeURIComponent(keep);
    window.location.replace(url);
  }, true);

  // apply a filter handed over from another member's page; with no
  // handover, sync to whichever pill Liquid marked active (so DT's page
  // filters to DT on a direct load)
  document.addEventListener('DOMContentLoaded', function () {
    var m = /[?&]gp_pill=([^&]+)/.exec(window.location.search);
    var pill = m
      ? document.querySelector('[data-gp-pillfilter="' + decodeURIComponent(m[1]) + '"]')
      : document.querySelector('[data-gp-pillfilter][aria-current]');
    if (pill) pill.click();
  });
})();
